import React from 'react';
import { Button } from 'antd';
import { DisconnectOutlined, ExportOutlined } from '@ant-design/icons';
import I18n from 'i18n-js';
import dayjs from 'dayjs';
import { bool, func } from 'prop-types';
import { ticket_path } from 'js-routes/generated/routes';
import StatusLabel from './StatusLabel';
import { selectedNodePropTypes } from '../propTypes';

const LinkedTicketCard = ({
  ticket, canManage = false, disabled = false, onOpen = () => {}, onUnlink = () => {},
}) => {
  const handleOpen = (event) => {
    event.preventDefault();
    onOpen(ticket);
  };

  const meta = [
    ticket.assignee?.username,
    I18n.t(`tickets.cwo_modules.${ticket.cwoModule}`),
    ticket.lastActivityAt && dayjs(ticket.lastActivityAt).format('LL'),
  ].filter(Boolean);

  return (
    <div className="tickets-index-page__linked-ticket">
      <div className="tickets-index-page__linked-ticket-header">
        <span className="tickets-index-page__linked-ticket-id">{`#${ticket.id}`}</span>
        <StatusLabel status={ticket.status} />
        <div className="tickets-index-page__linked-ticket-actions">
          <Button
            type="text"
            size="small"
            icon={<ExportOutlined />}
            href={ticket_path(ticket.id)}
            target="_blank"
            aria-label={I18n.t('tickets.form.open_in_new_tab')}
          />
          {canManage && (
            <Button
              type="text"
              size="small"
              icon={<DisconnectOutlined />}
              aria-label={I18n.t('tickets.form.unlink_ticket', { id: ticket.id })}
              disabled={disabled}
              onClick={() => onUnlink(ticket.id)}
            />
          )}
        </div>
      </div>

      <a
        className="tickets-index-page__linked-ticket-title"
        href={ticket_path(ticket.id)}
        onClick={handleOpen}
        title={ticket.title}
      >
        {ticket.title}
      </a>

      <div className="tickets-index-page__linked-ticket-meta">
        {ticket.assignee?.avatarUrl && <img src={ticket.assignee.avatarUrl} alt="" />}
        {meta.join(' · ')}
      </div>
    </div>
  );
};

LinkedTicketCard.propTypes = {
  ticket: selectedNodePropTypes.isRequired,
  canManage: bool,
  disabled: bool,
  onOpen: func,
  onUnlink: func,
};

export default LinkedTicketCard;
